import * as THREE from 'three';

// Translate a fixed 50-degree view with the die. Changing the zoom must never
// change the board's pitch or make its aim point trail at a different speed.
export const createBoardDieCamera = (tileRadius) => {
  const anchor = new THREE.Vector3();
  const pitch = THREE.MathUtils.degToRad(50);
  const offset = new THREE.Vector3(0, Math.sin(pitch) * 24, Math.cos(pitch) * 24);
  const projection = new THREE.PerspectiveCamera();
  const point = new THREE.Vector3();
  let started = false;
  let closeProgress = 0;
  return {
    reset() {
      started = false;
      closeProgress = 0;
    },
    update({ camera, look, position, velocity, delta, settled, reduceMotion }) {
      const firstFrame = !started;
      if (
        firstFrame ||
        anchor.distanceToSquared(position) > (tileRadius * 2) ** 2
      ) {
        anchor.copy(position);
        started = true;
      } else {
        anchor.lerp(position, reduceMotion ? 1 : 1 - Math.exp(-delta * 16));
      }
      closeProgress = Math.max(
        closeProgress,
        settled || reduceMotion
          ? 1
          : 1 - THREE.MathUtils.smoothstep(velocity.length(), 0.3, 15)
      );
      const radius =
        tileRadius * THREE.MathUtils.lerp(1.9, 1.05, closeProgress);
      camera.position.copy(anchor).add(offset);
      look.copy(anchor);
      camera.lookAt(look);
      if (camera.view?.enabled) camera.clearViewOffset();

      // Fit the local tile neighborhood, rather than the whole board or boss.
      // Use a centered projection so this zoom never introduces a moving aim.
      projection.copy(camera);
      projection.position.copy(offset);
      projection.lookAt(0, 0, 0);
      projection.zoom = 1;
      projection.updateProjectionMatrix();
      projection.updateMatrixWorld(true);
      let extent = 0;
      for (const x of [-radius, radius]) {
        for (const z of [-radius, radius]) {
          point.set(x, 0, z).project(projection);
          extent = Math.max(extent, Math.abs(point.x), Math.abs(point.y));
        }
      }
      const zoom = 0.82 / extent;
      camera.zoom = THREE.MathUtils.lerp(
        camera.zoom,
        zoom,
        firstFrame || reduceMotion ? 1 : 1 - Math.exp(-delta * 6)
      );
      camera.updateProjectionMatrix();
    },
  };
};
